import { isFunction } from '@direct-frontend/stdlib';
import { type SupportedIntegrationSyncTypes } from '#shared/lib/integrations';
import { showError } from '#shared/lib/toast';
import { ENDPOINT_UPDATE_INTEGRATION_SETTINGS } from './integrationSettingsUpdateEndpoints';

type EndpointUpdateIntegrationSettings = typeof ENDPOINT_UPDATE_INTEGRATION_SETTINGS;

export const updateIntegrationSettings = async <
    T extends SupportedIntegrationSyncTypes,
    P = EndpointUpdateIntegrationSettings[T],
>({
    syncType,
    payload,
    refetch,
    onError,
}: {
    syncType: T;
    payload: Partial<P>;
    refetch: VoidFunction;
    onError?: (error: unknown) => void;
}): Promise<boolean> => {
    try {
        await ENDPOINT_UPDATE_INTEGRATION_SETTINGS[syncType](payload);

        await refetch();
    } catch (error) {
        if (isFunction(onError) && error) {
            onError(error);
        } else {
            showError(
                { label: 'Произошла ошибка при обновлении настроек интеграции.' },
                error instanceof Error ? error.message : undefined
            );
        }

        return false;
    }

    return true;
};
